import { mutationTypes, getterTypes } from '../../../types';
import { BEACON_TYPE } from '../../../tools/consts';
export default store => {
	let oldAreaKeys = [];
	let oldNearbyArticles = [];

	store.subscribe((mutation, state) => {
		if (
			state.areaBeaconAlgorithm.config.isActive &&
			(mutation.type === mutationTypes.bluetoothScanStep || mutation.type === mutationTypes.setExhibitionID)
		) {
			// logger.log(('AreaBeaconScanStep: detectedBeacons', state.bluetooth.detectedBeacons));
			const newAreaBeacons = Object.entries(state.bluetooth.detectedBeacons).reduce((acc, keyVal) => {
				if (keyVal[1].type !== BEACON_TYPE.extender && keyVal[1].type !== BEACON_TYPE.area) return acc; // do nothing cause beaconType is not relevant for this alogrithm
				const beacon = JSON.parse(JSON.stringify(keyVal[1]));
				if (beacon.type === BEACON_TYPE.extender) {
					// Found extenderbeacon
					beacon.url = beacon.extendedURL;
					beacon.type = BEACON_TYPE.area;
				}
				if (beacon.type === BEACON_TYPE.area && oldAreaKeys.includes(beacon.url)) {
					beacon.rssi += state.areaBeaconAlgorithm.config.areaHysterese;
				}

				if (beacon.rssi >= state.areaBeaconAlgorithm.config.areaThreshold) {
					if (acc[beacon.url]) {
						// if beacon is allready set happens in case of externder beacons
						if (acc[beacon.url].rssi < beacon.rssi) {
							// override if rssi is smaller so best rssi is taken
							acc[beacon.url] = beacon;
						}
					} else {
						// normal case beacon with same id only exists once
						acc[beacon.url] = beacon;
					}
				}
				return acc;
			}, {});
			const newAreaKeys = Object.keys(newAreaBeacons);
			const newNearbyArticles = newAreaKeys.reduce((acc, beaconUrl) => {
				const beaconDesc = state.areaBeaconAlgorithm.descriptionMap[beaconUrl];
				if (beaconDesc) {
					acc.push(...beaconDesc);
				}
				return acc;
			}, []);
			if (
				newAreaKeys.length !== oldAreaKeys.length ||
				newNearbyArticles.length !== oldNearbyArticles.length ||
				newAreaKeys.filter(key => !oldAreaKeys.includes(key)).length > 0 ||
				newNearbyArticles.filter(key => !oldNearbyArticles.includes(key)).length > 0
			) {
				store.commit(mutationTypes.areaBeaconAlgorithmUpdate, {
					areaBeacons: newAreaBeacons,
					nearbyArticles: newNearbyArticles,
				});
				oldAreaKeys = newAreaKeys;
				oldNearbyArticles = newNearbyArticles;
			}
		}
		if (mutation.type === mutationTypes.bluetoothSetScanConfig) {
			let beaconDecriptions = [];
			if (state.bluetooth.config.mergeExhibitionBeacons) {
				state.dataSourceCFG.exhibitions.map(ex => {
					beaconDecriptions = beaconDecriptions.concat(ex.beacons);
				});
			} else if (store.getters[getterTypes.currentExhibition]) {
				beaconDecriptions = store.getters[getterTypes.currentExhibition].beacons;
			}
			store.commit(
				mutationTypes.areaBeaconSetConfig,
				state.dataSourceCFG.global.beaconSettings.areaBeaconAlgParameters
			);
			store.commit(mutationTypes.areaBeaconSetDescriptionMap, {
				descriptionMap: beaconDecriptions.reduce((acc, [uuid, beacon]) => {
					if (acc[uuid]) {
						acc[uuid].push(beacon.articleID);
					} else {
						acc[uuid] = [beacon.articleID];
					}
					return acc;
				}, {}),
			});
		}
	});
};
